import $ from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';

Rover.models = Rover.models || {};

Rover.models.RedemptionModel = Backbone.Model.extend({
  url() {
    return Rover.urls.redemptionUrl;
  },
  defaults: {
    code: null,
  },
});

const PAYMENT_METHOD_SORT_ORDER = ['promo', 'wallet'];

Rover.models.PromoMethodModel = Backbone.Model.extend({
  sortOrder: PAYMENT_METHOD_SORT_ORDER.indexOf('promo'),
  url() {
    return this.get('url');
  },
  defaults: {
    non_redeemable: null,
  },
  getTotalRoverBucks() {
    if (this.get('non_redeemable') === null) {
      return '0.00';
    }
    return parseFloat(this.get('non_redeemable')).toFixed(2);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/payments.js